module.exports = __webpack_public_path__ + "static/media/doctor-with-stethoscope-in-the-hands-and-hospital-background.dbeaeac1.png";